// API Configuration
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Abell Corporate Colors
export const COLORS = {
  primary: '#ae0404',        // Abell Red
  secondary: '#333333',      // Dark Grey
  background: '#f9f9f9',     // Light Background
  white: '#ffffff',
  text: '#333333',
  textLight: '#666666',
  success: '#10b981',
  warning: '#f59e0b',
  error: '#ef4444'
};

// User Roles
export const USER_ROLES = {
  ADMIN: 'admin',
  OPERATOR: 'operator',
  VIEWER: 'viewer'
};

// Local Storage Keys
export const STORAGE_KEYS = {
  TOKEN: 'abell_token',
  USER: 'abell_user'
};